import { combineReducers } from "redux";
import { reducer as fileDownloadReducer } from "./file-download/file-download-store";

export const hooksReducer = combineReducers({
  fileDownloadReducer
});
